import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody
} from "reactstrap"
import CardItem from "./CardItem"
import { providerPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import StatusModal from "./StatusModal"
import FilterIcon from "assets/images/filter.png"
import FilterModal from "./FilterModal";
import { useDispatch, useSelector } from "react-redux"
import ResaleService from "services/Provider/ResaleService"
import { appendFilters } from "store/adminFilter/actions"

const ResalePage = (props) => {
  const resaleService = new ResaleService()
  const [active, setActive] = useState("all")
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [restResales, setRestResales] = useState(0)
  const [modal, setModal] = useState(false)
  const [statusmodal, setStatusModal] = useState(false)
  const [editResale, setEditResale] = useState(null)
  const [location, setLocation] = useState("")
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const AuthData = useSelector(state => state.Auth)

  //const isExist = (data) => AuthData.permissions.includes(data)
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })

  const [filterArea, setFilterArea] = useState({
    area_id: null,
  })
  const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(appendFilters({developer_id: null}))
    },[])

  const addHandler = () => {
    props.history.push(`/sales-rep/resale/create-resale`)
  }
  const updateHandler = (id) => {
    props.history.push(`${providerPrefix}/resale/edit-resale/${id}`)
  }
  const viewHandler = (id) => {
    props.history.push(`${providerPrefix}/resale/view-resale/${id}`)
  }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)

  }
  useEffect(() => {
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active
      if (searchWord.trim().length) params['keyword'] = searchWord
      if (location) params["location"] = location
      params["rest_of_resales"] = restResales
      setFilterParams({ ...params })
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [active, searchWord, location, restResales])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Resale</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Resales</h4>
              <p>You can manage All Resales with diffrent status</p>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search by resale name, I.D" onChange={(e) => OnSearchChange(e)}
                  value={searchWord} />
              </div>
            </Col>
            <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button className="btn btn-success btnHeight px-lg-4" onClick={addHandler}>Add New Resale</button>
              </div>
            </Col>
          </Row>
          <Row className="my-4" >
            <Col sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "Live" ? "#556ee6" : "#f4f4f4",
                  color: active == "Live" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("Live")
                }}
              >
                Live
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "Rejected" ? "#556ee6" : "#f4f4f4",
                  color: active == "Rejected" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("Rejected")
                }}
              >
                Rejected
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "Pending" ? "#556ee6" : "#f4f4f4",
                  color: active == "Pending" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("Pending")
                }}
              >
                Pending
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "Sold" ? "#556ee6" : "#f4f4f4",
                  color: active == "Sold" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("Sold")
                }}
              >
                Sold
                            </button>
            </Col>
            <Col sm={4} className="mb-3 d-flex flex-row-reverse">
              <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                setModal(!modal)

              }}> <img src={FilterIcon} style={{ marginRight: "5px" }} /> Filter</button>
            </Col>
          </Row>
          <div>
            
            <Card className="w-100 mt-4 pt-4">
              <div className="d-flex" style={{justifyContent: "center"}}>
                <button className={restResales == 0 ? 'btn btn-primary' : 'btn btn-light'} 
                        style={{marginRight: '8px'}}
                        onClick={()=> setRestResales(0)}>My Resales</button>
                <button className={restResales == 1 ? 'btn btn-primary' : 'btn btn-light'}
                        onClick={()=> setRestResales(1)}>Rest of Resales</button>
              </div>
              <CardBody>
                <div className='py-2'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-14'>I.D</th>
                            <th className='font-size-14'>Seller Name</th>
                            <th className='font-size-14'>Unit Type</th>
                            <th className='font-size-14'>Rooms No</th>
                            <th className='font-size-14'>Floor No</th>
                            <th className='font-size-14'>Location</th>
                            <th className='font-size-14'>Compound</th>
                            <th className='font-size-14'>Status</th>
                            <th className='font-size-14'></th>
                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => {
                            return <CardItem
                              key={index}
                              index={index}
                              {...item}
                              item={item}
                              Service={ResaleService}
                              updateHandler={() => updateHandler(item.id)}
                              viewHandler={() => viewHandler(item.id)}
                              setStatusModal={setStatusModal}
                              setEditResale={() => setEditResale(item)}
                              setShouldGetData={setShouldGetData}
                            />
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-end" md={8} sm={12}>
                <Paginator
                  service={resaleService}
                  pageOptions={pageOptions}
                  setData={(data) => {
                    if(data?.length == 1 && data?.length > 0){
                      data[0].status !== "Not_Available" ? setList([...data]) : setList([])
                    }else{
                      let filteredData = data?.filter(item => item?.status !== "Not_Available")
                      setList([...filteredData])
                    }
                  }}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row>
          </div>
          {modal ? <FilterModal
            filterModal={modal}
            setFilterModal={() => setModal(!modal)}
            updateFiltersData={(data) => setSearchWord(data)}
            locationData={location}
          /> : null}
          {statusmodal ?<StatusModal
            modal={statusmodal}
            setShouldGetData={setShouldGetData}
            toggle={() => {
              setStatusModal(!StatusModal)
              setEditResale(null)
            }}
            editResale={editResale}
          />:null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ResalePage